import tableOperation from '../common/table-operation'

const getSearchedCallerIds = function (state) {
  const { table, callerIDs } = state
  const { searchText = "" } = table

  const matchVerifiedCallerIDPhoneNumber = (currentCallerID, value) =>
    currentCallerID?.phoneNumber?.toLowerCase()?.includes(value?.toLowerCase())

  const matchVerifiedCallerIDFriendlyName = (currentCallerID, value) =>
    currentCallerID?.friendlyName?.toLowerCase()?.includes(value?.toLowerCase())

  const searchedPhoneNumbers = tableOperation.applyClientSideFilter({
    searchQuery: searchText,
    filterConditions: [
      matchVerifiedCallerIDPhoneNumber,
      matchVerifiedCallerIDFriendlyName,
    ],
    collection: callerIDs,
  })

  return searchedPhoneNumbers
}

export default getSearchedCallerIds
